import { render, staticRenderFns } from "./GenreMenu.vue?vue&type=template&id=a87bf016&"
import script from "./GenreMenu.vue?vue&type=script&lang=ts&"
export * from "./GenreMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports